const messages = {
    loadVariables:"Loading all the variables",
    loadVariable:"Loading a variable",
    saveVariable:"Creating the new variable",
    modifyVariable:"Updating the variable",
    removeVariable:"Deleting the variable"
}
export default messages; 